import Controller from '../abstracts/Controller';
import 'scss-templates/t-homepage.scss';

export default class HomepageController extends Controller {
  static get COMPONENTS() {
    return [
      'EditorialComponent',
      'EditorialSliderComponent',
      'HeroComponent',
      'SimpleBarComponent',
      'GeneralComponentsComponent',
      'AddToWishlistComponent',
      'WishlistComponent',
      'PreHeaderComponent',
      'CountdownComponent',
      'ShopCategoryComponent',
      'CarouselModuleComponent',
    ];
  }
}
